import React, { useContext } from "react";
import { Button, Card, Table, Tag, Typography, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import useAssignedTraining from  "PlatForms/OrgLMS/Hooks/MentorHooks/useAssignedTraining";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const { Text } = Typography
const AssignedTrainings = () => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const { loadingGroups, groupData, loading } = useAssignedTraining();
  const navigate = useNavigate();
  const columns = [
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
      render: (text, record) => (
        <div style={{ position: "relative", display: "flex", alignItems: "center", }}>
          <Text strong>{text}</Text>
          {record.isRetryTraining && (
            <Tag color="orange" style={{ marginLeft: 8, fontWeight: "bold" }}>Repeated</Tag>
          )}
        </div>
      ),
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: "Members Count",
      dataIndex: "membersCount",
      key: "membersCount",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button type="link" onClick={() => navigate(`/assigned-group-detail/${record.id}`)}>
          View Detail
        </Button>
      ),
    },
  ];
  return (
    <Card
      title="Assigned Groups (For Trainings)"
      className="card-professional"
      loading={loading}
    >
      <>
        <Tooltip title={isBlocked ? "Complete your profile first" : ""}>
          <Table loading={loadingGroups} columns={columns} dataSource={groupData} rowKey="groupId"
            style={{ opacity: isBlocked ? 0.6 : 1, pointerEvents: isBlocked ? "none" : "auto" }} />
        </Tooltip>
      </>
    </Card>
  );
};
export default AssignedTrainings;
